import moment from 'moment';
import React, { useState, useEffect } from 'react';

const CommentSection = (props) => {


    return (
        <div className="" style={{height:400, overflow:`scroll`}}>
            {
                props.comments.length === 0 ? 
                <div className="text-center p-5">
                    <p><b>Komentar masih kosong</b></p>
                </div>
                    : 
                <div className='px-4 pt-3 pb-2 border-bottom'>
                    <h5>Kolom Komentar</h5>
                </div>
            }
            {
                props.comments.map(i => (
                    <div className={`border-bottom px-4 py-3 ${i.self ? '' : 'bg-gray-100'}`}>
                        {
                            i.self ? null :
                                <div className='badge badge-info'>
                                    {i.user_first_name}
                                </div>
                        }
                        <div className='row'>
                            <div className='col-9'>
                                {i.content}
                            </div>
                            <div className='col-3'>
                                <div className='px-1 text-center'>
                                    {moment(i.updated_at).format("HH:mm, DD MMM")}
                                </div>
                                
                            </div>
                        </div>
                       
                        
                        
                    </div>
                ))
            }
        </div>
    )
};

export default CommentSection